<template>
  <div>
    <v-row>
      <v-col>
        <v-toolbar dense>
          <v-toolbar-title style="padding: 8px 0px;">
            <div class="text-left">
              <h3>Monthly Expenses</h3>
            </div>
          </v-toolbar-title>
          <v-btn dark absolute bottom small right fab @click="triggerInput">
            <v-icon>mdi-plus</v-icon>
          </v-btn>

          <input
            hidden
            type="file"
            accept="image/*"
            @change="onFileChange"
            capture="camera"
            ref="inputFatura"
          />
        </v-toolbar>
      </v-col>
    </v-row>
    <ExpensesExportBanner />
    <ExpensesList />
  </div>
</template>

<script>
import ExpensesExportBanner from "@/components/expenses/ExpensesExportBanner.vue";
import ExpensesList from "@/components/expenses/ExpensesList.vue";
import { mapActions } from "vuex";
export default {
  components: {
    ExpensesList,
    ExpensesExportBanner
  },
  methods: {
    ...mapActions(["createNewExpense"]),
    triggerInput() {
      this.$refs.inputFatura.click();
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.createNewExpense(file);
    }
  }
};
</script>

<style scoped>
#preview {
  display: flex;
  justify-content: center;
  align-items: center;
}

#preview img {
  max-width: 100%;
  max-height: 500px;
}
</style>
